import { useState, useEffect } from "react";
import {
  getTopChannels,
  addNewTopChannel,
  deleteTopChannel,
  updateTopChannel
} from "../../api";

const defaultCountry = { label: "ALL", value: "ALL" };

export default function useTopChannels() {
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [topChannels, setTopChannels] = useState([]);
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState(null);
  const [type, setType] = useState(null);

  useEffect(() => {
    const req = async () => {
      setLoading(true);
      const res = await getTopChannels();
      const { data } = await res.json();

      setTopChannels(data);
      let countries = [...new Set(data.map(d => d.country))];
      countries = countries.map(c => ({ label: c, value: c }));
      countries.unshift(defaultCountry);
      setCountryOptions(countries);
      setLoading(false);
    };
    req();
  }, []);

  const onCountryChange = selected => {
    setSelectedCountry(selected);
  };

  const add = async body => {
    const res = await addNewTopChannel(body);
    const { data } = await res.json();
    topChannels.push(data);
    setTopChannels(topChannels);
    setLoading(false);
    showMessage("Successfully updated", "success");
  };

  const update = async (id, body) => {
    const res = await updateTopChannel(id, body);
    const { data } = await res.json();
    setTopChannels(
      topChannels.map(t => {
        if (t.id === id) {
          t = data;
        }
        return t;
      })
    );
    setLoading(false);
    showMessage("Successfully updated", "success");
  };

  const showMessage = (message, type = "success") => {
    setMessage(message);
    setType(type);
    setTimeout(() => {
      setMessage(null);
      setType(null);
    }, 3000);
  };

  const deleteChannel = async id => {
    setLoading(true);
    const res = await deleteTopChannel(id);
    await res.json();
    setTopChannels(topChannels.filter(t => t.id !== id));
    setLoading(false);
    showMessage("Successfully deleted", "success");
  };

  return {
    topChannels: topChannels.sort((a, b) =>
      a.country < b.country ? -1 : a.country === b.country ? 0 : 1
    ),
    loading,
    countryOptions,
    selectedCountry,
    onCountryChange,
    add,
    update,
    deleteChannel,
    message,
    type
  };
}
